<template>
  <div class="myAddress-panel">
    <!-- 头部操作与统计栏 -->
    <div class="header-action-bar">
      <div class="left-info">
        <h2 class="section-title">收货地址管理</h2>
        <span class="count-badge" v-if="!loading && addressList.length > 0">
          已维护 <em>{{ addressList.length }}</em> 个收货地址
        </span>
      </div>
      <el-button type="primary" icon="el-icon-plus" class="btn-add" @click="editOnline()">
        新增收货地址
      </el-button>
    </div>

    <!-- 加载骨架屏 -->
    <div v-if="loading" class="address-skeleton-grid">
      <div v-for="i in 3" :key="i" class="address-card-skeleton">
        <div class="sk-line sk-title"></div>
        <div class="sk-line sk-detail"></div>
        <div class="sk-line sk-addr"></div>
        <div class="sk-line sk-action"></div>
      </div>
    </div>

    <!-- 真实地址列表网格 -->
    <div v-else-if="addressList.length > 0" class="address-grid">
      <div class="address-card" v-for="(item, index) in addressList" :key="item.id || index">
        <div class="card-header">
          <div class="user-block">
            <span class="user-name">{{ item.mdbcej4opshigmrs }}</span>
            <span class="badge-badge" v-if="item['3ulvzh2pgygl0vga']">
              工号: {{ item['3ulvzh2pgygl0vga'] }}
            </span>
          </div>
          <span class="user-phone">
            <i class="el-icon-phone-outline"></i>
            {{ item.xejhteu0ub3fd3eh }}
          </span>
        </div>

        <div class="card-body">
          <div class="address-text">
            <i class="el-icon-location-information addr-icon"></i>
            <span class="region-text">
              {{
                item.b3ccmzbfyzlwy9sc && item.b3ccmzbfyzlwy9sc.length > 0
                  ? item.b3ccmzbfyzlwy9sc.map((el) => el.value).join(' ')
                  : ''
              }}
            </span>
            <span class="detail-text">{{ item['9simp0sjii9s0m33'] }}</span>
          </div>
        </div>

        <div class="card-footer">
          <div class="corp-tag">
            <i class="el-icon-office-building"></i>
            政企直达配送
          </div>
          <div class="btn-actions">
            <el-button type="text" icon="el-icon-edit" class="btn-edit" @click="editOnline(item)">编辑</el-button>
            <el-button type="text" icon="el-icon-delete" class="btn-del" @click="delOnline(item.id)">删除</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 空数据规范提示 -->
    <div v-else class="empty-state">
      <div class="empty-icon-wrap">
        <i class="el-icon-location-outline"></i>
      </div>
      <p class="empty-title">暂未添加收货地址</p>
      <p class="empty-sub">添加政企专属收货地址与配送科室，享受精准物流直达</p>
      <el-button type="primary" size="small" icon="el-icon-plus" @click="editOnline()">立即新增</el-button>
    </div>

    <!-- 地址编辑/新建弹窗 -->
    <el-dialog
      :title="form.id ? '编辑收货地址' : '新增收货地址'"
      :visible.sync="dialogVisible"
      width="520px"
      custom-class="gov-address-dialog"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="84px" size="medium" class="address-form">
        <el-form-item label="企业工号" required>
          <el-input
            v-model="form['3ulvzh2pgygl0vga']"
            placeholder="请输入员工工号或部门识别号"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人" required>
          <el-input
            v-model="form.mdbcej4opshigmrs"
            placeholder="请输入收货联系人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" required>
          <el-input
            v-model="form.xejhteu0ub3fd3eh"
            placeholder="请输入手机号码或座机分机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="所在地区" required>
          <el-cascader
            v-model="form.b3ccmzbfyzlwy9sc"
            :options="city"
            :props="props"
            placeholder="请选择省 / 市 / 区（县）"
            style="width: 100%;"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" required>
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入具体街道、院区大楼、楼层及房间/科室号"
            v-model="form['9simp0sjii9s0m33']"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="updateOnline()">保存地址</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { online, delOnline, updateOnline, postOnline } from "@/api/platform";
import city from '@/util/city'

export default {
  name: 'MyAddress',
  data () {
    return {
      form_head_uuid: '0f5b2fde26c04882a5d6c5c885a30a3f',
      addressList: [],
      loading: true,
      submitLoading: false,
      dialogVisible: false,
      form: {},
      city,
      props: {
        label: 'name',
        value: 'id'
      }
    }
  },
  mounted () {
    this.online()
  },
  methods: {
    async online () {
      this.loading = true
      try {
        const { form_head_uuid } = this
        const { result } = await online({
          page: 1,
          limit: 100,
          keyword: '',
          select_option: '',
          form_head_uuid,
        })
        this.addressList = Array.isArray(result) ? result : []
      } catch (e) {
        console.error("加载地址失败:", e)
        this.addressList = []
      } finally {
        this.loading = false
      }
    },
    // 删除地址
    async delOnline (id) {
      const { form_head_uuid } = this
      this.$confirm('确定要删除该收货地址吗？删除后将不可恢复。', '删除确认', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await delOnline({
            form_head_uuid,
            ids: [id]
          })
          this.$message.success('地址删除成功')
          this.online()
        } catch (e) {
          this.$message.error('删除地址失败，请稍后重试')
        }
      }).catch(() => {})
    },
    // 编辑详情
    editOnline (data) {
      if (data && data.id) {
        let form = JSON.parse(JSON.stringify(data))
        const { id, mdbcej4opshigmrs, b3ccmzbfyzlwy9sc, xejhteu0ub3fd3eh } = form
        this.form = {
          '3ulvzh2pgygl0vga': form['3ulvzh2pgygl0vga'],
          id,
          mdbcej4opshigmrs,
          xejhteu0ub3fd3eh,
          '9simp0sjii9s0m33': form['9simp0sjii9s0m33'],
          b3ccmzbfyzlwy9sc: Array.isArray(b3ccmzbfyzlwy9sc) ? b3ccmzbfyzlwy9sc.map(el => el.id) : []
        }
      } else {
        this.form = {
          '3ulvzh2pgygl0vga': '',
          mdbcej4opshigmrs: '',
          xejhteu0ub3fd3eh: '',
          b3ccmzbfyzlwy9sc: [],
          '9simp0sjii9s0m33': ''
        }
      }
      this.dialogVisible = true
    },

    async updateOnline () {
      const { form_head_uuid, form } = this
      const validations = [
        { field: '3ulvzh2pgygl0vga', error: '请输入工号' },
        { field: 'mdbcej4opshigmrs', error: '请输入联系人' },
        { field: 'xejhteu0ub3fd3eh', error: '请输入联系电话' },
        { field: 'b3ccmzbfyzlwy9sc', error: '请选择所在地区' },
        { field: '9simp0sjii9s0m33', error: '请输入详细地址' },
      ];
      for (const { field, error } of validations) {
        if (!form[field] || (Array.isArray(form[field]) && form[field].length === 0)) {
          return this.$message.warning(error);
        }
      }

      this.submitLoading = true
      try {
        if (this.form.id) {
          await updateOnline({
            ...this.form,
            form_head_uuid
          })
        } else {
          await postOnline({
            ...this.form,
            form_head_uuid
          })
        }
        this.$message.success(this.form.id ? '收货地址修改成功' : '收货地址添加成功');
        this.dialogVisible = false
        this.form = {}
        this.online()
      } catch (e) {
        this.$message.error('保存失败，请稍后重试');
      } finally {
        this.submitLoading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/var.less';

.myAddress-panel {
  width: 100%;

  .header-action-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f1f5f9;

    .left-info {
      display: flex;
      align-items: baseline;
      gap: 12px;

      .section-title {
        font-size: 16px;
        font-weight: 700;
        color: #0f172a;
        margin: 0;
      }

      .count-badge {
        font-size: 13px;
        color: #64748b;

        em {
          font-style: normal;
          font-weight: 700;
          color: @brandPrimary;
        }
      }
    }

    .btn-add {
      background-color: @brandPrimary;
      border-color: @brandPrimary;
      font-weight: 600;
      padding: 9px 18px;
      border-radius: 6px;
      transition: all 0.25s ease;

      &:hover {
        background-color: @brandSecondary;
        border-color: @brandSecondary;
        box-shadow: 0 4px 12px rgba(15, 82, 186, 0.25);
      }
    }
  }

  /* 骨架屏 */
  .address-skeleton-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
    gap: 16px;

    .address-card-skeleton {
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      padding: 18px;
      background: #fff;

      .sk-line {
        background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
        background-size: 200% 100%;
        animation: sk-shimmer 1.5s infinite;
        border-radius: 4px;
        margin-bottom: 12px;

        &.sk-title { width: 45%; height: 18px; }
        &.sk-detail { width: 65%; height: 14px; }
        &.sk-addr { width: 85%; height: 14px; }
        &.sk-action { width: 30%; height: 14px; margin-top: 16px; margin-bottom: 0; }
      }
    }
  }

  @keyframes sk-shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  /* 地址卡片网格 */
  .address-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
    gap: 16px;

    .address-card {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      padding: 16px 18px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;

      &:hover {
        border-color: @brandPrimary;
        box-shadow: 0 4px 16px rgba(15, 82, 186, 0.08);
        transform: translateY(-2px);
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        padding-bottom: 10px;
        border-bottom: 1px dashed #f1f5f9;

        .user-block {
          display: flex;
          align-items: center;
          gap: 8px;

          .user-name {
            font-size: 15px;
            font-weight: 700;
            color: #0f172a;
          }

          .badge-badge {
            font-size: 11px;
            background: #eff6ff;
            color: @brandPrimary;
            padding: 2px 7px;
            border-radius: 4px;
            font-weight: 600;
            border: 1px solid #dbeafe;
          }
        }

        .user-phone {
          font-size: 13px;
          color: #64748b;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 4px;

          i {
            color: #94a3b8;
          }
        }
      }

      .card-body {
        margin-bottom: 14px;
        flex: 1;

        .address-text {
          font-size: 13px;
          line-height: 1.6;
          color: #334155;
          display: flex;
          align-items: flex-start;
          gap: 6px;

          .addr-icon {
            color: @brandPrimary;
            font-size: 15px;
            margin-top: 2px;
            flex-shrink: 0;
          }

          .region-text {
            color: #64748b;
            margin-right: 4px;
          }

          .detail-text {
            color: #0f172a;
            font-weight: 500;
            word-break: break-all;
          }
        }
      }

      .card-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 10px;
        border-top: 1px solid #f8fafc;

        .corp-tag {
          font-size: 11px;
          color: #10b981;
          display: flex;
          align-items: center;
          gap: 4px;

          i { font-size: 12px; }
        }

        .btn-actions {
          display: flex;
          align-items: center;
          gap: 12px;

          .btn-edit {
            color: @brandPrimary;
            padding: 0;
            font-size: 13px;

            &:hover {
              color: @brandSecondary;
            }
          }

          .btn-del {
            color: #94a3b8;
            padding: 0;
            font-size: 13px;

            &:hover {
              color: #ef4444;
            }
          }
        }
      }
    }
  }

  /* 空状态 */
  .empty-state {
    padding: 60px 0;
    text-align: center;
    background: #ffffff;
    border: 1px dashed #cbd5e1;
    border-radius: 8px;

    .empty-icon-wrap {
      width: 64px;
      height: 64px;
      margin: 0 auto 16px;
      border-radius: 50%;
      background: #eff6ff;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 30px;
        color: @brandPrimary;
      }
    }

    .empty-title {
      font-size: 15px;
      font-weight: 600;
      color: #334155;
      margin: 0 0 6px;
    }

    .empty-sub {
      font-size: 13px;
      color: #94a3b8;
      margin: 0 0 18px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/client/MyAddress.vue